import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { SECONDS_TO_MILLIS } from "lopermut"
import { RunningImportsResponseDataSchema } from "schema"
import z from "zod"

type RunningImports = z.infer<typeof RunningImportsResponseDataSchema>

const REFETCH_INTERVAL = 20 * SECONDS_TO_MILLIS

export const runningCustomerImportsQueryKey = ["imports", "running"]

export function runningCustomerImportsQuery() {
  return queryOptions({
    queryKey: runningCustomerImportsQueryKey,
    queryFn: async (): Promise<RunningImports> => {
      const { data } = await axios.get<{ data: RunningImports }>("/importers/imports")
      return data.data
    },
    refetchInterval: REFETCH_INTERVAL,
  })
}
